import React        from 'react';
import CSSModules   from 'react-css-modules';
import moment       from "moment/moment";

import style from './style.scss';

import CPDTime      from '../CPDTime';
import ButtonLink   from '../ButtonLink';

import { courseTypeToLabel }    from '../../services/courseTypeLabelMapper';
import eventFormatter           from '../../services/eventFormatter';

class EventListItem extends React.Component {

    _getModuleBackgroundStyle() {

        const module = this.props.event.course.module;
        if(module) {
            return {
                backgroundColor: module.hex_colour
            };
        }
    }

    _getModuleColorStyle() {

        const module = this.props.event.course.module;
        if(module) {
            return {
                color: module.hex_colour
            };
        }
    }

    _lastFewPlacesLeft() {

        if(!this.props.event.fully_booked && this.props.event.attendees) {
            const placesLeft = this.props.event.max_delegates - this.props.event.attendees.length

            if (placesLeft <= 3) {
                return true;
            }

            return false;
        }

        return false

    }

    _getFullyBookedMessage() {

        if (this.props.event.fully_booked) {

            return (
                <div className={style['fully-booked']} style={this._getModuleColorStyle()}>
                    This event is now <br />fully booked
                </div>
            );
        }
    }

    _getLastFewPlaceMessage() {

        if(!this._getAlreadyStartedMessage()) { // do not show the last few place message if the course has started
            return (
                <div className={style['last-few-places-left']} style={this._getModuleColorStyle()}>
                    Last few places left
                </div>
            );
        }
    }

    _getAlreadyStartedMessage() {

        if(!this.props.event.fully_booked && this.props.event.multiple_days && moment(this.props.event.multiple_days_events[0].start_date).isBefore(moment.now()) && !this.props.event.fully_booked) {
            return (
                <div className={style['already-started']} style={this._getModuleColorStyle()}>
                    This event has<br />already started
                </div>
            );
        }

        return false;
    }

    _getEventAddress(event) {

        return (
            <span className={style['venue-info']}>
                { event.venue.address.address_1 }, { event.venue.address.town_city }
            </span>
        )
    }

    render() {

        const formattedEvent = eventFormatter.format(this.props.event);

        const courseType = this.props.event.course.type;

        return (
            <article { ...this.props } className={style['event']}>

                <div className={style['event-preview-mobile']}>
                    <div className={ style['module-image--'+courseType] } style={ this._getModuleBackgroundStyle() } />
                    <div className={style['box']}>
                        <div className={style['title-container']}>
                            <span className={style['subject-label']} style={ this._getModuleColorStyle() }>
                                Subject
                            </span>
                            <div className={style['module-title']}>
                                { formattedEvent.course.module.name }
                            </div>
                        </div>
                    </div>

                    <div className={style['box']}>
                        <div className={style['course-title']}>
                            <div style={ this._getModuleColorStyle() }>{courseTypeToLabel(formattedEvent.course.type)}</div>

                            { formattedEvent.course.name }
                        </div>
                    </div>

                    <div className={style['box']}>
                        <div className={ formattedEvent.fully_booked ? style['event-title--fully-booked'] : style['event-title'] }>
                            <div style={ formattedEvent.fully_booked ? null : this._getModuleColorStyle() }>Event</div>

                            {formattedEvent.multiple_days && (
                                formattedEvent.multiple_days_events.map((event_days) => {
                                    return (
                                        <div>
                                            <span className={style['event-date']}>
                                                {eventFormatter.getFormattedEventDate(event_days)}
                                            </span>
                                            <span className={style['event-time']}>
                                                {eventFormatter.getFormattedEventStartTime(event_days)}&ndash;{eventFormatter.getFormattedEventEndTime(event_days)}
                                            </span>
                                        </div>
                                    )

                                })
                            )}

                            {!formattedEvent.multiple_days && (
                                <div>
                                    <span className={style['event-date']}>
                                        {eventFormatter.getFormattedEventDate(formattedEvent)}
                                        </span>
                                    <span className={style['event-date']}>
                                        {eventFormatter.getFormattedEventStartTime(formattedEvent)}&ndash;{eventFormatter.getFormattedEventEndTime(formattedEvent)}
                                    </span>
                                </div>
                            )}

                            { this._getEventAddress(formattedEvent)}
                        </div>
                    </div>

                    <div className={style['box']}>
                        <div className={style['cpd-title']}>
                            <div style={ this._getModuleColorStyle() }>CPD</div>

                            <div className={style['cpd-info']}>
                                { formattedEvent.padded_cpd_hours } hours<br/>
                                { formattedEvent.padded_cpd_minutes } minutes
                            </div>
                        </div>
                    </div>

                    { this._lastFewPlacesLeft() && (
                        this._getLastFewPlaceMessage()
                    )}

                    <div className={style['action-button-container']}>
                        <div className={style['action-button']}>

                            <ButtonLink to={ `/events/${ this.props.event.id }/${ this.props.event.course.slug }` } style={ this._getModuleBackgroundStyle() }>
                                Details
                            </ButtonLink>

                        </div>

                        <div className={style['action-button']}>

                            {formattedEvent.multiple_days &&
                            !moment(formattedEvent.multiple_days_events[0].start_date).isBefore(moment.now()) ||
                            !formattedEvent.multiple_days && (
                                <ButtonLink
                                    disabled={ formattedEvent.fully_booked }
                                    to={ `/booking/${ this.props.event.id }` }
                                    style={ this._getModuleBackgroundStyle() }
                                    className={style[formattedEvent.fully_booked ? 'booking-button-disabled' : '']}
                                >
                                    Book Now
                                </ButtonLink>
                            )}

                        </div>

                        { this._getAlreadyStartedMessage() }
                        { this._getFullyBookedMessage() }

                    </div>

                </div>

                <div className={style['event-preview']}>

                    <div className={style['box']}>
                        <span className={style['subject-label']} style={ this._getModuleColorStyle() }>
                            Subject
                        </span>
                        <div className={style['module-title']}>
                            { formattedEvent.course.module.name }
                        </div>
                        <div className={ style['module-image--'+courseType] } style={ this._getModuleBackgroundStyle() } />

                    </div>

                    <div className={style['box']}>
                        <div className={style['course-title']}>
                            <div style={ this._getModuleColorStyle() }>{courseTypeToLabel(formattedEvent.course.type)}</div>

                            { formattedEvent.course.name }
                        </div>

                        <div className={style['action-button']}>

                            <ButtonLink to={ `/events/${ this.props.event.id }/${ this.props.event.course.slug }` } style={ this._getModuleBackgroundStyle() }>
                                Details
                            </ButtonLink>

                        </div>
                    </div>

                    <div className={style['box']}>
                        <div className={ formattedEvent.fully_booked ? style['event-title--fully-booked'] : style['event-title'] }>
                            <div style={ formattedEvent.fully_booked ? null : this._getModuleColorStyle() }>Event</div>
                            {formattedEvent.multiple_days && (
                                formattedEvent.multiple_days_events.map((event_days) => {
                                    return (
                                        <div>
                                            <span className={style['event-date']}>
                                                {eventFormatter.getFormattedEventDate(event_days)}
                                            </span>
                                            <span className={style['event-time']}>
                                                {eventFormatter.getFormattedEventStartTime(event_days)}&ndash;{eventFormatter.getFormattedEventEndTime(event_days)}
                                            </span>
                                        </div>
                                    )

                                })
                            )}

                            {!formattedEvent.multiple_days && (
                                <div>
                                    <span className={style['event-date']}>
                                        {eventFormatter.getFormattedEventDate(formattedEvent)}
                                        </span>
                                    <span className={style['event-date']}>
                                        {eventFormatter.getFormattedEventStartTime(formattedEvent)}&ndash;{eventFormatter.getFormattedEventEndTime(formattedEvent)}
                                    </span>
                                </div>
                            )}

                            {courseType === "webinar" ? (
                                <span className={style['venue-info']}>Webinar</span>
                            ) : (
                                <div>
                                    { this._getEventAddress(formattedEvent)}
                                </div>
                            )}


                            { this._lastFewPlacesLeft() && (
                                this._getLastFewPlaceMessage()
                            )}

                        </div>

                        <div className={style['action-button']}>

                            {formattedEvent.multiple_days && moment(formattedEvent.multiple_days_events[0].start_date).isBefore(moment.now()) && (
                                this._getAlreadyStartedMessage()
                            )}

                            {((formattedEvent.multiple_days &&
                                !moment(formattedEvent.multiple_days_events[0].start_date).isBefore(moment.now())) ||
                                !formattedEvent.multiple_days) && (
                                    <ButtonLink
                                        disabled={ formattedEvent.fully_booked }
                                        to={ `/booking/${ this.props.event.id }` }
                                        style={ this._getModuleBackgroundStyle() }
                                        className={style[formattedEvent.fully_booked ? 'booking-button-disabled' : '']}
                                    >
                                        Book Now
                                    </ButtonLink>
                                )}
                        </div>

                        { this._getFullyBookedMessage() }
                    </div>

                    <div className={style['box']}>
                        <div className={style['cpd-title']}>
                            <div style={ this._getModuleColorStyle() }>CPD</div>

                            <div className={style['cpd-info']}>
                                { formattedEvent.padded_cpd_hours } hours<br/>
                                { formattedEvent.padded_cpd_minutes } minutes
                            </div>
                        </div>

                        <div className={style['event__info-boxes']}>

                            <CPDTime hours={ formattedEvent.padded_cpd_hours }
                                     minutes={ formattedEvent.padded_cpd_minutes }
                                     style={ this._getModuleBackgroundStyle() }/>

                        </div>
                    </div>

                </div>

            </article>
        );
    }
}

export default CSSModules(EventListItem, style);


// WEBPACK FOOTER //
// ./components/EventListItem/index.js